import { PlatformLanguage } from "@/generated-api/models/PlatformLanguage";
import { useGetAccountSettings } from "@/tanstack-hooks";
import { enUS, Locale, ru } from "date-fns/locale";

const LOCALE_MAP: Record<PlatformLanguage, Locale> = {
  [PlatformLanguage.ENGLISH]: enUS,
  [PlatformLanguage.RUSSIAN]: ru,
};

export const useGetAccountLocale = () => {
  const { data } = useGetAccountSettings();
  const language = data?.preferred_language || PlatformLanguage.ENGLISH;
  return LOCALE_MAP[language] || enUS;
};
